/* JOINMELI - Kisiye ozel secenegi (urun sayfasi). 12.10.26 */
if (!customElements.get('meli-ozel')) {
  customElements.define('meli-ozel', class extends HTMLElement {
    connectedCallback() {
      this.check = this.querySelector('.meli-ozel__check');
      this.fields = this.querySelector('.meli-ozel__fields');
      this.isimRow = this.querySelector('[data-ozel-isim]');
      this.logoRow = this.querySelector('[data-ozel-logo]');
      this.isim = this.querySelector('.meli-ozel__isim');
      this.logo = this.querySelector('.meli-ozel__logo');
      this.idInput = this.querySelector('.meli-ozel__id');
      this.feeInput = this.querySelector('.meli-ozel__fee');
      this.check.addEventListener('change', () => this.update());
      this.querySelectorAll('input[name="meli-ozel-tur"]').forEach((r) => r.addEventListener('change', () => this.update()));
      const formId = this.dataset.formId;
      /* form.id, name="id" girdisi yuzunden kullanilamaz; getAttribute kullan */
      document.addEventListener('submit', (e) => {
        const f = e.target;
        if (f && f.getAttribute && f.getAttribute('id') === formId && this.check.checked) {
          this.newId();
        }
      }, true);
      document.addEventListener('product-ajax:added', () => { if (this.check.checked) this.newId(); });
      this.update();
    }
    newId() {
      this.idInput.value = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    }
    setField(row, input, on) {
      if (!row || !input) return;
      row.hidden = !on;
      input.hidden = !on;
      input.disabled = !on;
      if (!on) { input.classList.remove('form-control--warning'); }
    }
    update() {
      const on = this.check.checked;
      this.fields.hidden = !on;
      const tur = (this.querySelector('input[name="meli-ozel-tur"]:checked') || {}).value || 'isim';
      this.setField(this.isimRow, this.isim, on && tur === 'isim');
      this.setField(this.logoRow, this.logo, on && tur === 'logo');
      this.idInput.disabled = !on;
      if (on && !this.idInput.value) this.newId();
      this.feeInput.disabled = !on;
    }
  });
}
